import { ExplorerEnvService } from '../env/explorer-env.service';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExplorerRouting extends BaseRouting {
  static configPath = ':configId';
  static APP_ROUTE = 'explorer';
  static explorationPath = 'exploration';
  static explorationDefaultPath = '';
  static explorationManagerPath = 'exploration-manager';
  static explorationManagerDefaultPath = '';

  private _explorationDefault: string[] = [ExplorerRouting.explorationPath];
  private _explorationManagerDefault: string[] = [ExplorerRouting.explorationManagerPath];

  constructor(explorerEnv: ExplorerEnvService) {
    super(['/' + ExplorerRouting.APP_ROUTE, ExplorerRouting.configPath], explorerEnv);
  }

  public explorationDefault(configId: string = this.getConfigId()): void {
    this.nav(this._explorationDefault, {
      configId
    });
  }

  public explorationDefaultUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._explorationDefault, {
      configId
    });
  }

  public explorationManagerDefaultUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._explorationManagerDefault, {
      configId
    });
  }
}
